import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <footer className="main-footer">
                <div className="pull-right hidden-xs">
                    <b>Versão</b> 1.0.0
            </div>
                <strong>Copyright &copy; 2019 <a href="#">SENC App</a>.</strong> Todos os direitos reservados.
          </footer>
        )

    }
}
